import { render, staticRenderFns } from "./EvolutionsList.vue?vue&type=template&id=b65fab60&scoped=true&"
import script from "./EvolutionsList.vue?vue&type=script&lang=js&"
export * from "./EvolutionsList.vue?vue&type=script&lang=js&"
import style0 from "./EvolutionsList.vue?vue&type=style&index=0&id=b65fab60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65fab60",
  null
  
)

export default component.exports